/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MemoryMountAccess,
  MemoryMountAccess$inboundSchema,
  MemoryMountAccess$outboundSchema,
} from "./memorymountaccess.js";

export type MemoryMount = {
  storeId: string;
  label: string;
  access?: MemoryMountAccess | undefined;
};

/** @internal */
export const MemoryMount$inboundSchema: z.ZodType<
  MemoryMount,
  z.ZodTypeDef,
  unknown
> = z.object({
  store_id: z.string(),
  label: z.string(),
  access: MemoryMountAccess$inboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    "store_id": "storeId",
  });
});
/** @internal */
export type MemoryMount$Outbound = {
  store_id: string;
  label: string;
  access?: string | undefined;
};

/** @internal */
export const MemoryMount$outboundSchema: z.ZodType<
  MemoryMount$Outbound,
  z.ZodTypeDef,
  MemoryMount
> = z.object({
  storeId: z.string(),
  label: z.string(),
  access: MemoryMountAccess$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    storeId: "store_id",
  });
});

export function memoryMountToJSON(memoryMount: MemoryMount): string {
  return JSON.stringify(MemoryMount$outboundSchema.parse(memoryMount));
}
export function memoryMountFromJSON(
  jsonString: string,
): SafeParseResult<MemoryMount, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MemoryMount$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MemoryMount' from JSON`,
  );
}
